import React from 'react';
import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';

const Container = styled.div`
  width: 1100px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  padding: var(--home-block-padding) 0;
  ${flexGap('16px')}
`;

const JetImg = styled.img`
  object-fit: cover;
`;

const DescBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  ${flexGap('20px')}
  background: #f4f6fc;
  padding: 24px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  ${flexGap('8px')}
`;

const Title = styled.h2`
  font-weight: 600;
  font-size: 40px;
  margin: 0;
  line-height: normal;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${flexGap('32px')}
`;

const Desc = styled.h3`
  font-weight: 400;
  font-size: 16px;
  color: #424748;
  line-height: 1.3;
  margin: 0;
`;

const Link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 41px;
  background: #fff;
  color: #424748;
  cursor: pointer;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  &:hover {
    color: #050a30;
  }
`;

const ToLearnMore = styled(Link)`
  background: #1f68db;
  color: #fff;
  &:hover {
    color: #fff;
  }
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  ${flexGap('8px')}
`;

const Benefits = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  ${flexGap('16px')}
`;

const BenefitsTitle = styled.p`
  font-weight: 600;
  font-size: 16px;
`;

const Kinds = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
`;

const Kind = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${flexGap('12px')}
  border-bottom: 1px solid #dde2e4;
  padding: 0 16px;
  &:first-child {
    padding: 0 8px;
  }
  &:last-child {
    border-bottom: none;
  }
`;

const Img = styled.img`
  width: 24px;
  height: 24px;
`;

const KindDesc = styled.span`
  font-weight: 600;
  font-size: 20px;
`;

const BenefitsKinds = [
  '24/7 Concierge',
  'Discounted Flights',
  'Complimentary In-flight Amenities',
  'Chauffeur Service',
  'Exclusive Member Benefits and much more!',
];

const Membership = () => {
  return (
    <Container>
      <DescBox>
        <TitleBox>
          <Title>Private Jet Memberships</Title>
          <Desc>Introducing an even more flexible way to travel by charter jet.</Desc>
        </TitleBox>
        <Footer>
          <Box>
            <Desc>
              Rent a private jet and experience the advantages of private aviation for your personal
              or corporate travel needs
            </Desc>
            <Benefits>
              <BenefitsTitle>Enjoy the benefits of a private air charter, including:</BenefitsTitle>
              <Kinds>
                {BenefitsKinds.map((item, index) => (
                  <Kind key={index}>
                    <Img src="/imgs/svg/home/done-all-rounded.svg" alt="done all" />
                    <KindDesc>{item}</KindDesc>
                  </Kind>
                ))}
              </Kinds>
            </Benefits>
          </Box>

          <ToLearnMore href="/membership">Learn more</ToLearnMore>
        </Footer>
      </DescBox>
      <JetImg
        src="/imgs/webp/home/membership.webp"
        alt="Executive jet interior with polished wood finishes"
      ></JetImg>
    </Container>
  );
};

export default Membership;
